import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Heart, Play } from "lucide-react";

interface ActionBarProps {
  onLike: () => void;
  onWatchVideo: () => void;
  onPop: () => void;
  onSuperPop?: () => void;
  isPopping?: boolean;
  isPremium?: boolean;
}

const ActionBar = memo(({ 
  onLike, 
  onWatchVideo, 
  onPop, 
  isPopping = false,
}: ActionBarProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="flex items-center justify-center gap-3 px-4">
      {/* Like Button - Pink/red with heart and P icon */}
      <button
        onClick={onLike}
        className="flex items-center gap-2 px-5 py-3 rounded-full bg-gradient-to-r from-rose-500 to-pink-500 text-white font-semibold shadow-lg hover:scale-105 active:scale-95 transition-all duration-200"
        aria-label={t("popBalloon.like")}
      >
        <Heart className="w-5 h-5 fill-current" />
        <span className="text-lg font-bold">P</span>
      </button>
      
      {/* Watch Video Button - Center */}
      <button
        onClick={onWatchVideo}
        className="flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-gray-700 to-gray-800 text-white font-semibold shadow-lg hover:scale-105 active:scale-95 transition-all duration-200"
      >
        <Play className="w-5 h-5 fill-current" />
        <span>{t("popBalloon.watchVideo")}</span>
      </button>
      
      {/* Pop Button */}
      <button
        onClick={onPop}
        className={`flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-rose-500 to-pink-500 text-white font-semibold shadow-lg hover:scale-105 active:scale-95 transition-all duration-200 ${isPopping ? "animate-shake animate-pulse-glow" : ""}`}
      >
        <Heart className="w-5 h-5 fill-current" />
        <span>{t("popBalloon.pop")}</span>
      </button>
    </div>
  );
});

ActionBar.displayName = "ActionBar";

export default ActionBar;
